import React, { useEffect, useMemo } from "react";
import Peer from "@/components/videoCalling/Peer";
import { selectPeers, useHMSStore } from "@100mslive/react-sdk";
import "@/styles/components/videoCalling.scss";
import { Col, Row } from "antd";

const Conference = ({ setLocalPeerId, setHostIds, fetchRoomDetails }) => {
  const peers = useHMSStore(selectPeers);
  const hostDetails = useMemo(() => peers.filter((p) => p.roleName === "host"), [peers]);
  useEffect(() => {
    setHostIds(hostDetails.map((x) => x.id));
  }, [hostDetails]);

  useEffect(() => {
    setTimeout(() => {
      fetchRoomDetails();
    }, 2000);
  }, [peers]);

  return (
    <div className="conference-section">
      <div style={{ overflow: "hidden", padding: "10px" }}>
        {/* <Flex
          style={{
            margin: "0.5rem 0",
          }}
        >
          {hostDetails.length ? (
            <div>{moment(hostDetails[0].joinedAt).format("lll")}</div>
          ) : (
            <></>
          )}
        </Flex> */}
        <Row className="peers-container" gutter={[16, 16]}>
          {peers?.map((peer) => (
            <Col md={peers.length >= 3 ? 8 : 12} sm={24} xs={24} key={peer.id}>
              <Peer key={peer.id} peer={peer} setLocalPeerId={setLocalPeerId} />
            </Col>
          ))}
        </Row>
      </div>
    </div>
  );
};

export default Conference;
